const ADMIN_URL = process.env.REACT_APP_ADMIN_URL

const Admin = {
  ADMIN_URL
}

export default Admin
